import { CredentialType, ThirdPartySystemId, type SecretListItem } from '@anchorbase/pillar-sdk';
import { Button } from '@/components/ui/button';
import { OmnisearchSelect } from '@/components/ui/omnisearch-select';
import { secretsApi } from '@/lib/pillarApi';

export function ValorBinLookupConfigEditor(props: {
    readonly organizationUuid: string;
    readonly selectedCredentialUuid: string;
    readonly onSelectedCredentialUuidChange: (credentialUuid: string) => void;
}) {
    return (
        <div className="space-y-3">
            <OmnisearchSelect<SecretListItem, string>
                label="Valor virtual terminal credential"
                placeholder="Search merchant credentials..."
                pageSize={25}
                fetchPage={async ({ terms, limit, cursor }) => {
                    const response = await secretsApi.listSecrets(
                        { organization_uuid: props.organizationUuid },
                        {
                            credential_type: CredentialType.VIRTUAL_TERMINAL,
                            system_ids: [ThirdPartySystemId.VALOR_US],
                            terms: terms === undefined ? undefined : [...terms],
                            exclude_policy_linked: true,
                            limit,
                            cursor,
                        }
                    );
                    return {
                        items: response.secrets,
                        pagination: response.pagination ?? { has_more: false },
                    };
                }}
                getItemId={(credential) => credential.credential_uuid}
                getItemLabel={(credential) =>
                    credential.account_id || credential.credential_uuid
                }
                getItemFilterText={(credential) =>
                    `${credential.account_id} ${credential.masked_preview}`
                }
                selectedItemId={props.selectedCredentialUuid || null}
                selectedItemLabel={props.selectedCredentialUuid || undefined}
                onSelect={(credential) => {
                    props.onSelectedCredentialUuidChange(credential.credential_uuid);
                }}
                onClearSelection={() => {
                    props.onSelectedCredentialUuidChange('');
                }}
            />
            <p className="text-sm text-muted-foreground">
                Need another credential? Create a Valor virtual terminal credential in Integrated
                Payments Gateway Credentials below, then return here to select it.
            </p>
            <Button
                type="button"
                variant="outline"
                onClick={() => {
                    document.getElementById('ipg-credentials-card')
                        ?.scrollIntoView({ block: 'start' });
                }}
            >
                Manage Valor credentials
            </Button>
        </div>
    );
}
